export function takeAnother<T>(list: T[], current: T) {
  return list.filter((listItem) => listItem !== current)[0] || current
}
